import { Modal } from "react-bootstrap";
import styled from "styled-components";

import { colors, modalStyles } from "../../common/styles/Theme";

const StyledCustomModal = styled(Modal)`
  background-color: ${colors.blackTransparency045};

  .modal-body {
    padding: 0;
    overflow-y: auto;
  }

  .modal-body-container {
    padding: 16px 16px 16px 32px;
  }

  .modal-dialog {
    max-width: 1188px;
  }

  .modal-content {
    ${modalStyles.normalModalStyle};
    width: ${(props) => props.width || "1188px"} !important;
    margin: 0 auto;
    border-radius: 8px;

    .modal-header {
      border: none;
      background: ${colors.GreyF8};
      display: flex;
      flex-shrink: 0;
      align-items: center;
      justify-content: space-between;
      padding: 16px 16px 8px 32px;

      .main-title-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
      }

      .subHeading {
        margin-top: 2px;
      }
    }
  }

  .modal-footer {
    border-top: 0.5px solid ${colors.GreyE1};
    background: ${colors.White};
    padding: 12px 32px;
    display: flex;
    align-items: center;
    gap: 8px;
    width: 100%;

    * {
      margin: 0;
    }

    .action-btns {
      display: flex;
      gap: 8px;
      margin-left: auto;
    }
  }
`;

export default StyledCustomModal;
